import { FormGroup } from '@angular/forms';
import { CitadelErrorLoggingService } from '@citadel/core';

/** Logs the form's errors and values (a password only by its length) under `auth.input`. */
export function logFormErrors(errorLogging: CitadelErrorLoggingService, form: FormGroup, name: string) {
  // BUG (found adopting strict mode, fixed here): form.errors[key] read form.errors again,
  // unguarded - if it was null (the `|| {}` only covered the Object.keys call), this threw.
  const formErrors = form.errors || {};
  const errors = Object.keys(formErrors).map(key => `${key}: ${formErrors[key]}`).join(', ');
  const values = Object.keys(form.value || {}).map(key => `${key}: ${key === 'password' ? form.value[key]?.length || 0 : form.value[key]}`).join(', ');
  errorLogging.logError('auth.input', `${name} Errors: ${errors}\nValue: ${values}`);
}

/** Logs the form's errors whenever it turns invalid. */
export function logWhenInvalid(errorLogging: CitadelErrorLoggingService, form: FormGroup, name: string) {
  form.statusChanges.subscribe(status => {
    if (status === 'INVALID') {
      logFormErrors(errorLogging, form, name);
    }
  });
}
